import type { ArgoCDApplicationResource, EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import { EnvironmentsTagList } from "~/areas/infrastructure/components/ArgoCDInstances/components/EnvironmentsTagList";
type ArgoCDApplicationEnvironmentsTagListProps = {
    application: ArgoCDApplicationResource;
    environments: EnvironmentV2Resource[];
};
export const ArgoCDApplicationEnvironmentsTagList = (props: ArgoCDApplicationEnvironmentsTagListProps) => {
    const environmentIds = [...new Set(props.application.Sources.map((src) => src.EnvironmentId).filter((id) => id !== null))];
    return <EnvironmentsTagList environmentIds={environmentIds} environments={props.environments}/>;
};
